import { useMutation } from '@tanstack/react-query';
import deleteTokenApiCall from 'api/calls/deleteTokenApiCall';

const useDeleteTokenMutation = () => useMutation(deleteTokenApiCall);

export default useDeleteTokenMutation;
